import React from "react";
import PropTypes from "prop-types";
import { Card as SemanticCard } from "semantic-ui-react";
import "./HuiCard.scss";

export const HuiCard = ({
  color,
  size,
  label,
  shadow = false,
  ...props
}) => {
  return (
    <SemanticCard
      {...props}
      className={`hireart-ds-card ${shadow ? "shadowed" : null} ${
        props.type || "prod-hd-02"
      } ${props.className}`}
    >
      {props.children}
    </SemanticCard>
  );
};

HuiCard.propTypes = {
  type: PropTypes.oneOf(["lean-hd", "prod-hd-03", "prod-hd-02", "stat-header"]),
  shadow: PropTypes.bool,
};

